/*
 * @Descripttion:
 * @Version: 1.0
 * @Author: 张家彬
 * @Date: 2024-04-07 10:45:17
 * @LastEditors: 孙松林
 * @LastEditTime: 2025-09-16 17:55:44
 */
// 运行时配置

// import Avatar from '@/components/Avatar';
// 全局初始化数据配置，用于 Layout 用户信息和权限初始化
// 更多信息见文档：https://umijs.org/docs/api/runtime-config#getinitialstate
import state from '@/models/store';
import { AxiosError, RequestConfig, history } from '@umijs/max';
import { message, notification } from 'antd';
import Layout from './layouts/ConfigLayout';
import { storageToken } from './utils/enum';
export interface AuthInfo {
  status: number;
  authCode: string;
  authType: string;
  componentServer: string;
  componentServerName: string;
  merchantId: string;
  expireTime: number;
  issuedTime: number;
  isSupportSM: number;
  nodeLimitNum: number;
}
export interface InitialState {
  name?: string;
  authInfo: Partial<AuthInfo> | null;
}
export async function getInitialState(): Promise<InitialState> {
  const obj = { authInfo: null };
  return obj;
}
export const layout = Layout;
const BASE_URL = '/dasApi';

const skipApiList = ['/contract/save', '/contract/update/version'];
interface TsError extends Error {
  config?: any;
  code?: string;
}
export const request: RequestConfig<{ config: any; code?: string }> = {
  errorConfig: {
    errorThrower(res) {
      throw res;
    },
    errorHandler(res: AxiosError | TsError) {
      if (res.code !== '0' && !res.name) {
        message.error({ content: res.message, key: 'globalHttp' });
      } else {
        const { config } = res;
        //过滤不使用notification提示的列表
        const findIndex = skipApiList.findIndex((item) => {
          if (!item) return false;
          return config?.url.indexOf(item) >= 0;
        });
        if (findIndex >= 0) {
          return res;
        }
        notification.error({
          message: '服务连接异常',
          key: 'globalHttp',
          description: res.message,
        });
      }
      return res;
    },
  },
  requestInterceptors: [
    (url, options) => {
      const baseUrl = BASE_URL + url;
      const token = localStorage.getItem(storageToken);
      if (token) {
        options.headers['X-Token'] = token;
        console.log('请求携带token:', token);
      } else {
        console.log('请求未携带token');
      }
      return {
        url: baseUrl,
        options,
      };
    },
  ],
  responseInterceptors: [
    (response) => {
      const { skipErrorHandler } = response?.config;
      if (skipErrorHandler) return response;
      // 不再需要异步处理读取返回体内容，可直接在data中读出，部分字段可在 config 中找到
      const { data = {} as any, config } = response;
      const pathname = history.location.pathname;
      
      console.log('响应数据:', data);
      console.log('当前路径:', pathname);
      
      // 检查是否为token相关错误码
      if (['U_002', 'U_017', 'U_001'].indexOf(data?.code) >= 0) {
        console.log('检测到token错误:', data.code);
        
        // 如果是子应用内的页面，跳转到子应用的登录页
        if (pathname.startsWith('/market')) {
          console.log('在子应用内，跳转到子应用登录页');
          localStorage.removeItem(storageToken);
          state.refreshPage = !state.refreshPage;
          return false;
        } else {
          // 其他情况跳转到主应用登录页
          console.log('不在子应用内，跳转到主应用登录页');
          history.push('/login');
        }
      }
      
      return response;
    },
  ],
};
